"use strict";
exports.__esModule = true;
var events_1 = require("events");
var log_1 = require("../util/log");
var ExtEndpointModuleBus = /** @class */ (function () {
    function ExtEndpointModuleBus() {
        this.busMap = new Map();
    }
    ExtEndpointModuleBus.prototype.getBus = function (busType) {
        if (!this.busMap.has(busType)) {
            this.busMap.set(busType, new events_1.EventEmitter());
        }
        return this.busMap.get(busType);
    };
    ExtEndpointModuleBus.prototype.on = function (busType, eventName, handler, only) {
        if (only === void 0) { only = false; }
        var bus = this.getBus(busType);
        if (only) {
            bus.removeAllListeners();
        }
        bus.on(eventName, handler);
    };
    ExtEndpointModuleBus.prototype.off = function (busType, eventName) {
        var bus = this.getBus(busType);
        bus.removeAllListeners(eventName);
    };
    ExtEndpointModuleBus.prototype.clean = function (extUuid, extName, extType) {
        var _this = this;
        Array.from(this.busMap.keys()).forEach(function (busType) {
            log_1.debugLog("\u3010\u76D1\u542C\u3011\u6E05\u7406\u901A\u9053\u3010" + extUuid + "\u3011\u3010" + extName + "\u3011\u3010" + extType + "\u3011\u3010" + busType + "\u3011");
            _this.busMap.get(busType).removeAllListeners();
        });
    };
    return ExtEndpointModuleBus;
}());
exports["default"] = ExtEndpointModuleBus;
